var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.023 2.462a.76.76 0 0 0 0 1.076l3.229 3.228a.77.77 0 0 0 .058.053.76.76 0 0 0 1.13.059l5.054-5.055A.761.761 0 0 0 9.418.747L4.901 5.264 2.1 2.462a.76.76 0 0 0-1.077 0Z",
    fill: "#4673EC"
  })));
};

export default SvgCheck;